import React from 'react';
import { Icon } from 'ui';

const OwnershipOptions = ({ children }) => (
  <div className="dropdown float-right">
    <button
      type="button"
      data-action="tag-dropdown"
      data-toggle="dropdown"
      className="u-resetBtn dropdown-toggle"
    >
      <Icon name="settings" />
    </button>
    <div className="dropdown-menu" role="menu">
      {children}
    </div>
  </div>
);

export default OwnershipOptions;
